import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-public-home',
    templateUrl: './public-home.component.html',
    styleUrls: ['./public-home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublicHomeComponent implements OnInit {

  deviceInfo!: any;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  // La messagerie a besoin de toute la largeur : pas de colonne « Deals les + hot »
  showSidebar: boolean = true;

  // router optionnel : les barres du footer instancient aussi ce composant avec `new` (sans router)
  constructor( private deviceService: DeviceDetectorService, private router?: Router ) {
    this.epicFunction();}

  ngOnInit(): void {
    if (!this.router) {
      return;
    }
    this.updateSidebar(this.router.url);
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => this.updateSidebar(event.urlAfterRedirects));
  }

  private updateSidebar(url: string) {
    // Pages avec leur propre colonne latérale : pleine largeur, sans « Deals les + hot »
    this.showSidebar = !['/messages', '/compte', '/poster'].some(prefix => url.startsWith(prefix));
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }


  scrollToTop()
  {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

}
